import mixin from "../mixin";
import { MAIN_CONTRACT } from '../utils/constants';

export default {
    name: "info",
    mixins: [mixin],
    created() {
        this.account = this.$route.params.account;
        this.getBaseInfo();
    },
    data() {
        return {
            account: '',
            title: '',
            avatar: '',
            desc: '',
            website: '',
            telegram: '',
            twitter: '',
            facebook: '',
            wechat: '',
            cost: '',
            modifier: '',
            hasInfo: false,
            status: '',
            verified: ''
        }
    },
    methods: {
        getBaseInfo() {
            this.readonlyEos.getTableRows(true,
                MAIN_CONTRACT,
                MAIN_CONTRACT,
                "accounts",
                "",
                this.account,
                this.account,
                1).then(res => {
                if (!!res.rows.length) {
                    let info = res.rows[0];
                    this.hasInfo = true;
                    this.title = info.title;
                    this.avatar = info.avatar;
                    this.desc = info.desc;
                    this.modifier = info.modifier;
                    this.status = info.status;
                    let basePrice = parseFloat(info.price);
                    if (this.account === this.currentAccount) {
                        this.cost = parseFloat(basePrice / 2).toFixed(4) + ' EOS';
                    } else {
                        this.cost = parseFloat(basePrice * 1.5).toFixed(4) + ' EOS';
                    }

                    this.verified = info.verified;

                    if (info.url) {
                        try {
                            let url = JSON.parse(info.url);
                            this.website = url.website;
                            this.telegram = url.telegram;
                            this.twitter = url.twitter;
                            this.wechat = url.wechat;

                        } catch (err) {
                            console.log(err);
                        }
                    }
                } else {
                    this.hasInfo = false;
                    this.title = this.$t('i18nView.empty');
                    this.desc = this.$t('i18nView.empty');
                    this.modifier = this.$t('i18nView.empty');
                }
            })
        },
        goEdit() {
            this.$router.push('/edit/' + this.account);
        }
    }
};